const hStyle = { backgroundColor: '#f1f9ef', color: '#609426', fontSize: 9, fontWeight: 'bold' };


export default hStyle;